import type { TFunction } from 'i18next';
import type { PasswordPolicy } from '@/types/provider-auth-settings';

export function formatPasswordPolicyRules(
  t: TFunction,
  policy: Partial<PasswordPolicy> | null | undefined,
): string[] {
  if (!policy) {
    return [];
  }

  const rules: string[] = [];

  if (typeof policy.minLength === 'number' && policy.minLength > 0) {
    rules.push(
      t('auth.passwordPolicy.minLength', 'At least {{count}} characters.', {
        count: policy.minLength,
      }),
    );
  }

  if (policy.requireNumbers) {
    rules.push(t('auth.passwordPolicy.requireNumbers', 'At least one number.'));
  }

  if (policy.requireSymbols) {
    rules.push(t('auth.passwordPolicy.requireSymbols', 'At least one symbol.'));
  }

  if (policy.requireMixedCase) {
    rules.push(t('auth.passwordPolicy.requireMixedCase', 'Upper and lower case letters.'));
  }

  if (typeof policy.disallowPrevious === 'number' && policy.disallowPrevious > 0) {
    rules.push(
      t('auth.passwordPolicy.disallowPrevious', 'Cannot reuse your last {{count}} passwords.', {
        count: policy.disallowPrevious,
      }),
    );
  }

  return rules;
}
